module.exports = __webpack_public_path__ + "img/the-netherlands-ill-defined-causes-male.988668ec.png";